import React, { forwardRef, memo } from 'react'

import TableHead from './TableHead'
import TableRow from './TableRow'
import TableHeadCell from './TableHeadCell'
import TableSortLabel from './TableSortLabel'
import { Checkbox } from '../index'
import { util } from '../../../util'

const EnhancedTableHead = (
    {
        headCells,
        onRequestSort,
        order,
        orderBy,
        className,
        onChange,
        checked,
        isScrollable,
        hideCheckBox,
        isPartial,
        disableHeadCheckbox,
    },
    ref
) => {
    const headClass = i => util.joinClasses(i === 0 && isScrollable && 'fixed head')

    return (
        <TableHead className={className}>
            <TableRow>
                {hideCheckBox !== true && (
                    <TableHeadCell
                        className={util.joinClasses(isScrollable && 'fixed head')}
                        align={'center'}
                        style={{ width: isScrollable ? '80px' : '5%' }}
                    >
                        <Checkbox
                            isPartial={isPartial}
                            onChange={onChange}
                            checked={checked > 0 || false}
                            isDisabled={disableHeadCheckbox}
                        />
                    </TableHeadCell>
                )}
                {headCells.map(({ id, label, sortable, align, width }, i) => (
                    <TableHeadCell
                        ref={cellRef => {
                            if (ref && ref.current) {
                                ref.current[label] = cellRef
                            }
                        }}
                        key={id}
                        width={!isScrollable ? width : null}
                        align={align}
                        className={headClass(i, label)}
                    >
                        <TableSortLabel
                            sortable={sortable}
                            active={orderBy === id}
                            direction={orderBy === id ? order : 'asc'}
                            onClick={() => (sortable ? onRequestSort(id) : undefined)}
                        >
                            {label}
                        </TableSortLabel>
                    </TableHeadCell>
                ))}
            </TableRow>
        </TableHead>
    )
}

export default memo(forwardRef(EnhancedTableHead))
